import { Component, OnInit, AfterViewInit, Input, ViewChild} from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

import {UnitOfWork, StateMap } from '../../services/common';
import { UtilFns, LocationFns } from '../../utils/common';
import { PageState, ColumnSorter } from '../../controls/common';

import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { DxDataGridComponent } from 'devextreme-angular';

import { ROUTES } from '../routes';
import { ReferenceAuthor } from '../../entities/EntityModels';

class PageStateExt extends PageState {
    operatorName: string;
    searchTerm: string;
}

@Component ({
    selector: 'search-authors',
    templateUrl: './search-authors.html'
})
export class SearchAuthorsComponent implements OnInit, AfterViewInit  {
    @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

    _componentInitializing = true;
    _pageStatusMessage: string;
    _totalItemCount = 0;

    _operators = [
        { name: 'startsWith', title: 'StartingWith' },
        { name: 'contains', title: 'Containing' }
    ];

    _pageSize = 50;
    _pageState = new PageStateExt('Author References');

    dataSource: DataSource;

    constructor(public _uow: UnitOfWork, public _stateMap: StateMap,
        public _location: Location, public _router: Router ) {
    }

    ngOnInit() {

        this._pageState.operatorName = this._operators[0].name;

        // setTimeout needed because of Angular RC5 bug where Location is not set correctly until
        // after timeout resolves.
        // setTimeout(() => {
        //     LocationFns.updatePageState(this._location, this._stateMap, this._pageState, (state: PageState) => {
        //         this._colSorter.sortColumn = state.sortColumn;
        //         this.search();
        //     });
        // }, 0);

        this.defineGridCustomDataStore();
    }

    ngAfterViewInit() {
        if (this.dataGrid) {
            this.dataGrid.visible = false;
        }
    }

    opChange(event: any) {
        // avoid thrashing
        const opName = event.target.value;
        if (this._pageState.operatorName == opName) { return; }
        this._pageState.operatorName = opName;

        // if (this.isValidString(this._pageState.searchTerm)) {
        //     this.newSearch();
        // }
    }

    newSearch() {
        this._pageStatusMessage = '';
        this._pageStatusMessage = '';

        this.dataGrid.visible = true;
        this.dataGrid.instance.pageIndex(0);
        this._pageState.resetPaging();

        this.getReferenceAuthorSearchTotalCount(this._pageState.searchTerm, this._pageState.operatorName).then(() => {
            this.dataGrid.instance.refresh();
        });
    }

    clear() {
        this._pageState.searchTerm = '';
        this._pageState.resetPaging();
        this._pageStatusMessage = '';

        if (this.dataGrid.visible) {
            this._componentInitializing = true;
            this.dataGrid.instance.pageIndex(0);
            this.dataGrid.instance.refresh();
            this.dataGrid.visible = false;
        }
    }

    public getReferenceAuthorSearchTotalCount(authorName: string, opType: string): Promise<any> {

        const params = { authorName: authorName, opType: opType};
        return this._uow.fetch('References/FetchReferenceAuthorSearchCount', params).then( c => {
            if (c != null && c.length > 0) {
                this._totalItemCount = c[0];
            } else {
                this._totalItemCount = 0;
            }
        });
    }

    onSelectReferenceAuthor(evt: any) {
        const ra = <ReferenceAuthor> evt.selectedRowsData[0];

        this._router.navigate(UtilFns.asRouterParts(ROUTES.Reference, ra.reference.referenceId));

        return false;
    }

    getGridElement(id: string): any {
        return jQuery('#' + id);
    }

    defineGridCustomDataStore() {
        this.dataSource = new DataSource({
            store: new CustomStore({
                load: (loadOptions: any) => {
                    if (this._componentInitializing) {
                        this._pageState.isLoading = false;
                        this._pageState.itemCount = 0;
                        this._pageState.isLoadedWithNoData = true;
                        this._componentInitializing = false;
                        return Promise.resolve({data: [], totalCount: 0});
                    }

                    let sort = {name: 'authorName', isDesc: false};
                    if (loadOptions.sort) {
                        sort = {
                            name: loadOptions.sort[0].selector,
                            isDesc: !!loadOptions.sort[0].desc
                        };
                    }

                    const skip = loadOptions.skip ? loadOptions.skip / loadOptions.take : 0;

                    this._pageState.isLoading = true;

                    const opValue = {} as any;
                    const searchTerm = this._pageState.searchTerm.replace(/\&/g, '%26');
                    opValue[this._pageState.operatorName] = searchTerm;
                    const pred = {'author.authorName': opValue};
                    const orderBy = 'author.authorName';

                    this._pageState.isLoading = true;
                    return this._uow.referenceAuthorRepository.wherePaged(pred, orderBy, skip + 1, this._pageSize)
                        .then( r => {
                        if (r != null && r.length > 0) {
                            this._pageState.itemCount = r.length;
                            this._pageStatusMessage = this._totalItemCount + ' matching Author References found.';
                        } else {
                            this._pageState.itemCount = 0;
                            this._pageState.isLoadedWithNoData = true;
                            this._pageStatusMessage = 'No matching Author References found that match your search criteria';
                            this.dataGrid.visible = false;
                        }
                        this._pageState.isLoading = false;
                        return {
                            data: r,
                            totalCount: this._totalItemCount
                        };
                    });
                }
            })
        });
    }

    hasStatusMessage(): boolean {
        return this.isValidString(this._pageStatusMessage);
    }

    isValidString(teststring: string) {
        if (!teststring) { return false; }

        return (teststring.trim().length > 0);
    }
}
